import { PropTypes } from "prop-types"
import React from "react"
import Embed from "./Embed"
import { loadIframely } from "./utils"

const EmbedDisplay = ({ embedCode }) => {
  React.useEffect(() => {
    loadIframely()
  }, [embedCode])

  return <Embed code={embedCode} />
}

EmbedDisplay.propTypes = {
  embedCode: PropTypes.string.isRequired
}

export default EmbedDisplay
